import { useWsmWorkoutAlertsSource } from "./useWsmWorkoutAlertsSource";
import { useCloudWorkoutAlertsSource } from "./useCloudWorkoutAlertsSource";
import { PLATFORM_ENUM, WorkoutAlertInputType } from "@WahooFitness/cloud-client-types";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { WSMWorkoutAlert } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";

export type IWorkoutAlertSource = {
  workoutAlerts: WSMWorkoutAlert[] | undefined;
  workoutAlertsAreLoading: boolean;
  workoutAlertsError: Error | undefined;
  reloadWorkoutAlerts: () => void;
  createWorkoutAlert: (alert: WorkoutAlertInputType) => Promise<WSMWorkoutAlert | undefined | null>;
  editWorkoutAlert: (
    workoutAlertExternalId: string,
    edits: WorkoutAlertInputType
  ) => Promise<WSMWorkoutAlert | undefined | null>;
  deleteWorkoutAlert: (workoutAlertExternalId: string) => Promise<boolean | null>;
};

export const useWorkoutAlertsSource = (workoutProfileExternalId: string): IWorkoutAlertSource => {
  const { platform } = useConfigContext();
  const offlineProfilesEnabled = platform !== PLATFORM_ENUM.web;

  const wsmAlertsSource = useWsmWorkoutAlertsSource(
    workoutProfileExternalId,
    offlineProfilesEnabled
  );
  const cloudAlertsSource = useCloudWorkoutAlertsSource(
    workoutProfileExternalId,
    !offlineProfilesEnabled
  );

  return offlineProfilesEnabled ? wsmAlertsSource : cloudAlertsSource;
};
